<template>
  <v-app cloak>
    <v-navigation-drawer
    permanent
    app
    v-if="$route.meta.showNavigation"
    :mini-variant.sync="mini"
    >
      <v-list-item>
        <v-btn
          icon
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
          dense
          nav
        >
          <v-list-item
            v-for="item in menu_items"
            :key="item.title"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-navigation-drawer>
  <v-app-bar
    app
    dense
    v-if="$route.meta.showNavigation">
    <div class="flex-grow-1"></div>
    <!--<v-btn icon>
      <v-icon>mdi-magnify</v-icon>
    </v-btn>-->
    <v-btn icon>
      <v-icon @click="logout_from_app">mdi-export-variant</v-icon>
    </v-btn>
  </v-app-bar>

  <!-- Sizes your content based upon application components -->
  <v-main>

    <!-- Provides the application the proper gutter -->
    <v-container fluid>

      <!-- If using vue-router -->
      <router-view
        :api_prefix="api_prefix"
        :user="user"
        :subscription_plan="subscription_plan"
        :setup_completed="setup_completed"
        @subscription_plan_updated="get_subscription_plan"
      >
      </router-view>
    </v-container>
  </v-main>

  <v-footer app>
    <!-- -->
  </v-footer>
</v-app>
</template>

<script>
var WebFont = require('webfontloader');
import router from './router.js';
const firebase = require('firebase/app');
require('firebase/auth');
let chatwoot_has_loaded = false;

//could also do:
//npm install --save material-design-icons-iconfont
//and import it in the main.js file
//import 'material-design-icons-iconfont/dist/material-design-icons.css'
WebFont.load({
  google: {
    families: ['Roboto', 'Material+Icons']
  }
})

window.addEventListener('chatwoot:ready', function() 
{
  chatwoot_has_loaded = true;
});

export default {
  name: 'app',
  metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'lighty',
  },
  data: function () {
    return {
      user: null,
      token: null,
      setup_completed: null,
      nav_drawer: null,
      mini: false,
      api_prefix: process.env.VUE_APP_API_PREFIX,
      subscription_plan: null,
      active_subscription: null,
      is_mobile: false,
      counter: 0,
      chatwoot_ready: false,
      force_refresh: false,
      menu_items:
      [
        {
          'title': 'Settings', 'icon': 'mdi-database', 'link': '/settings'
        },
        {
          'title': 'Subscription', 'icon': 'show_chart', 'link': '/subscription'
        },
        {
          'title': 'Help', 'icon': 'help', 'link': '/help'
        }
      ],
    }
  },
  created()
  {
        let self = this;

        console.log('in app api prefix is:' + self.api_prefix);
        console.log(process.env.VUE_APP_FIREBASE_API_KEY);

        this.firebase_token();
  },
  components: {
    //'navigation-sidebar': NavigationSidebar,
  },
  methods: {
    async get_setup_completed()
    {
        try
        {
          let self = this;
          var response = await this.$http.get(self.api_prefix + '/setup_completed',
          {});
          self.setup_completed = response.data;
          //set the localstorage to the setup_completed value
          localstorage.setItem('setup_completed', self.setup_completed);
        }
        catch (error)
        {
        }
    },
    async get_subscription_plan()
    {
        try
        {
          let self = this;
          var response = await this.$http.get(self.api_prefix + '/subscription',
          {});
          self.subscription_plan = response.data.plan;
          self.active_subscription = response.data.active;
          var event = new CustomEvent("subscription", {detail: {"plan": self.subscription_plan, "active": self.active_subscription}});
          window.dispatchEvent(event);

          if(self.chatwoot_ready)
          {
            self.set_chatwoot_plan()
          }
        }
        catch (error)
        {
        }
    },
    set_nav_bar_size()
    {
      if (('ontouchstart' in document.documentElement && navigator.userAgent.match(/Mobi/))==false)
      {
        this.mini = false;
      }
      else
      {
        this.mini = true;
      }
    },
    logout_from_app()
    {
      firebase.default.auth().signOut().then(function() 
      {
        // Sign-out successful.
        console.log('signed out');
        var event = new CustomEvent("logged_out", {detail: {}});
        window.dispatchEvent(event);
      }, function(error) 
      {
        // An error happened.
      });
      router.push("login")
    },
    chatwoot_loaded()
    {
      let self = this;
      if(self.user!=null)
      {
        self.set_chatwoot_user()
      }
      if(self.subscription_plan!=null && self.active_subscription!=null)
      {
        self.set_chatwoot_plan()
      }
      self.chatwoot_ready = true
    },
    firebase_token()
    {
        /*
        Shortly before the current ID token expires, the modern client SDKs transparently send the refresh token to this endpoint 
        to generate a fresh ID token with a new one hour expiry, ensuring your users stay logged in. All of this happens under the hood, 
        although each client SDK includes a method to be notified when a new ID token is generated
        BUT:
        On its own the Auth service will not proactively refresh (as this is an expensive operation and it may be unnecessary if there is no consumer of the new token). 
        Other firebase services (realtime db, firestore) need the persistent connection, so they need to continuously do so.
        */
        //triggered on sign-in, sign-out, and token refresh events
        //https://firebase.google.com/docs/reference/js/firebase.auth.Auth.html#on-idtoken-changed
        let self = this;
        firebase.default.auth().onIdTokenChanged(user =>
        {
            if (user)
            {
                self.user = user;
                self.user.getIdToken().then(function(token)
                {
                  console.log('onIdTokenChanged')
                  console.log(token);
                  self.token = token;

                  //leverage Axios interceptors to append the token to every request
                  self.$http.interceptors.request.use(async config => {
                    //https://github.com/axios/axios#request-config
                    //self.token = localStorage.getItem('token')
                    self.token = await firebase.default.auth().currentUser.getIdToken() // we don't use the token that's saved after login, as it expires every hour.  this caches or gets a new one as necessary
                    config.headers.Authorization = 'Bearer ' + self.token
                    return config
                  }, (error) => {
                    return Promise.reject(error)
                  })

                  self.get_subscription_plan();
                });
                window.analytics.identify(self.user.uid,
                {
                  name: self.user.displayName,
                  email: self.user.email
                });
                if(self.chatwoot_ready)
                {
                  self.set_chatwoot_user()
                }
                var event = new CustomEvent("logged_in", {detail: {"user_id": self.user.uid}});
                window.dispatchEvent(event);
            }
        });
    },
    set_chatwoot_user()
    {
      let self = this;
      window.$chatwoot.setUser(self.user.uid, 
      {
        email: self.user.email,
        name: self.user.displayName,
      });
    },
    set_chatwoot_plan()
    {
      let self = this;
      window.$chatwoot.setCustomAttributes({
        subscription_plan: self.subscription_plan,
        active_subscription: self.active_subscription
      });
    }
  },
  mounted: function()
  {
    this.set_nav_bar_size()
    window.vue_app = this;
    if(chatwoot_has_loaded==true)
    {
      this.chatwoot_loaded();
    }
  },
  computed: 
  {
  },
  watch: 
  {
    '$route' (to, from) 
    {
      let self = this;
      document.title = to.meta.title || 'lighty'
      setTimeout(self.set_nav_bar_size, 1500);
    },
  },

}
</script>

<style scoped>
[v-cloak] {display: none}
a:hover
{
  text-decoration: none;
}
.container, .container--fluid
{
	height: 100%;
}
</style>
